import { ORDENABLE_PAGE_SIZE } from '@/constants';
import { listActivities } from '@/data/services/activityServices';

type ExamActivityListParams = {
  examAreaIds: number[];
};

export const examActivityQueries = {
  all: ['exam-activities'] as const,

  list: ({ examAreaIds }: ExamActivityListParams) => {
    const sorted = [...examAreaIds].sort((a, b) => a - b);
    return {
      queryKey: [
        ...examActivityQueries.all,
        'list',
        { examAreaIds: sorted },
      ] as const,
      queryFn: () =>
        listActivities({
          examAreaId: sorted,
          pageSize: ORDENABLE_PAGE_SIZE,
        }),
    };
  },
};
